{
  "title": "Aura of Purity",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level abjuration",
  "level": 4,
  "castingTime": "1 action",
  "range": "Self (30-foot radius)",
  "components": "V",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Purifying energy radiates from you in an aura with a 30-foot radius. Until the spell ends, the aura moves with you, centered on you. Each non-hostile creature in the aura (including you) can’t become diseased, has resistance to poison damage, and has advantage on saving throws against effects that cause any of the following conditions: blinded, charmed, deafened, frightened, paralyzed, poisoned, and stunned."
  ],
  "spellLists": ["cleric", "paladin"]
}
